import React from 'react';
import LandingMediaKitMediaLabProduction from '../TNOMediaKitMediaLabProduction/LandingMediaKitMediaLabProduction';
import {
  bvdMediaLabWho,
  bvdMediaLabWhy,
  bvdMediaLabBenefits,
  bvdMediaLabValues,
  bvdMediaLabAreYouReady,
} from '../TNOMediaKitMediaLabProduction/bvdMediaLabContent';

const LandingMediaKitBolsaValoresDescentralizada = (props) => (
  <LandingMediaKitMediaLabProduction
    {...props}
    proposalSlug="bolsa-valores-descentralizada"
    mediaLabContent={{
      who: bvdMediaLabWho,
      why: bvdMediaLabWhy,
      benefits: bvdMediaLabBenefits,
      values: bvdMediaLabValues,
      areYouReady: bvdMediaLabAreYouReady,
    }}
  />
);

export default LandingMediaKitBolsaValoresDescentralizada;
